import type { Metadata } from "next";

export const SITE_URL = process.env.UI_URL
	? process.env.UI_URL.replace(/\/$/, "")
	: "https://meetploy.com";

export const SITE_NAME = "Ploy";

export const SITE_TAGLINE = "The open serverless cloud";

export const SITE_DESCRIPTION =
	"Ploy is an open-source serverless cloud for apps and AI agents. Git push to deploy, with databases, queues, cron, durable workflows, sandboxes, auth, and model access built in, on infrastructure you control.";

export function canonical(path = "/") {
	return new URL(path, SITE_URL).toString();
}

/**
 * Metadata for pages that must stay out of the index — auth flows and
 * token-scoped pages. They carry no search value and would otherwise compete
 * with the homepage on a duplicated title.
 */
export function noindexMetadata(title: string): Metadata {
	return {
		title: `${title} | ${SITE_NAME}`,
		robots: { index: false, follow: false },
	};
}

/** Routes that must never be indexed: authenticated app, auth flows, and one-off token pages. */
export const NOINDEX_PATHS = [
	"/dashboard",
	"/project",
	"/onboarding",
	"/invite",
	"/join",
	"/login",
	"/signup",
	"/forgot-password",
	"/reset-password",
];
